var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M20.574 10.945v7.107c0 .52-.43.948-.952.948h-5.717v-5.686h-3.81V19H4.378c-.52 0-.952-.43-.952-.948v-7.107c0-.03.015-.06.015-.088L12 3.837l8.56 7.02c.014.03.014.06.014.088zm3.32-1.02l-.923 1.094c-.074.088-.193.148-.312.162h-.044c-.12 0-.224-.03-.313-.103L12 2.535 1.7 11.08c-.105.073-.224.117-.358.102-.12-.014-.238-.074-.313-.163L.105 9.923c-.163-.193-.134-.504.06-.666L10.87.388c.624-.518 1.636-.518 2.26 0l3.633 3.02V.523c0-.267.21-.474.477-.474h2.858c.268 0 .476.207.476.474v6.04l3.26 2.696c.194.162.223.473.06.666z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c96f423a2769f6068a01c3759294dd56.svg";
export { ForwardRef as ReactComponent };